mutation CardHolderDelete($input: CardHolderDeleteInput!) {
  cardHolderDelete(input: $input) {
    deletedEntities {
      id
      rowTimestamp
    }
  }
}
